var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Talk to "+_vm._s(_vm.member.name)+" about:")]),_vm._l((_vm.member.opportunities),function(value,opportunity){return _c('ul',[_c('li',[_vm._v(_vm._s(opportunity))])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }